import { SkillBuilderAttribute } from "~utils";

/**
 * In an effort to de-couple Question attribute values (question.attribute) from API response
 * to avoid tests from throwing TS errors should question attribute names change or be removed
 * we are using this function to convince TS that the string values passed are indeed a
 * SkillBuilderAttribute["attribute"]
 * @param attribute a string
 */
export function assertIsSkillBuilderAttribute(
  attribute: string,
): asserts attribute is SkillBuilderAttribute["attribute"] {
  if (typeof attribute !== "string") {
    throw new Error("value must be a string");
  }
}

/**
 * Formats a skillbuilder attribute name into a human-readable string.
 * Handles both district-specific and Swing-specific skillbuilder formats.
 *
 * For district skillbuilders (3-part format):
 * Input: "test-district-a.make-it-right.skill-check/outro"
 * Output: "Make It Right"
 *
 * For Swing skillbuilders (2-part format):
 * Input: "classroom-management.skill-check/outro"
 * Output: "Classroom Management"
 *
 * @param skillbuilderOutroAttribute - The skillbuilder attribute string to format
 * @returns A formatted, human-readable string with proper capitalization and spacing
 */
export function formatSkillBuilderOutroName(skillbuilderOutroAttribute: string) {
  let result = "";
  const skillbuilderAttrSplit = skillbuilderOutroAttribute.split(".");

  // districts have 3 parts
  // expected format: test-district-a.make-it-right.skill-check/outro
  // result: ["test-district-a", "make-it-right", "skill-check/outro"]

  if (skillbuilderAttrSplit.length === 3) {
    result = skillbuilderAttrSplit[1];
  }

  // Swing has 2 parts
  // expected format: lwc.skill-check/outro
  // result: ["lwc", "skill-check/outro"]

  if (skillbuilderAttrSplit.length === 2) {
    result = skillbuilderAttrSplit[0];

    // special one-off case for lwc (lwc.skill-check/outro)
    if (result === "lwc") {
      return "Lead With Confidence";
    }

    // FIXME: find a better way to handle this
    if (result === "az-mrt") {
      return "Arizona Mandated Reporter Training";
    }
  }

  // remove hyphens, capitalize first letter of each word, and join with a space
  const formattedResult = result
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return formattedResult;
}
